import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'

export function Login() {
  const { signInWithOtp, session, profile } = useAuth()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const location = useLocation()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    try {
      await signInWithOtp(email)
      setSent(true)
    } catch (err: any) {
      setError(err?.message ?? 'Failed to send magic link')
    }
  }

  // If arriving via magic link, normalize to /login and continue
  useEffect(() => {
    const hasToken = location.hash.includes('access_token') || location.search.includes('access_token')
    if (!hasToken && !session) return
    // If we have a session (either recovered from hash or already logged in), route by intent/role
    const intended = (location.state as any)?.from?.pathname
    const byRole = profile?.role === 'ADMIN' ? '/admin' : profile?.role === 'ADVISOR' ? '/advisor' : '/'
    navigate(intended || byRole, { replace: true })
  }, [location, session, profile, navigate])

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="card max-w-md w-full text-center">
          <h1 className="text-2xl font-bold mb-2">Check your email</h1>
          <p className="text-sm text-gray-600">We sent a magic link to {email}.</p>
          <button className="btn-secondary mt-4" onClick={() => navigate('/')}>Return Home</button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card max-w-md w-full">
        <h1 className="text-2xl font-bold mb-4">Sign in</h1>
        {error && <div className="mb-3 text-sm text-red-600">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Email</label>
            <input className="input-field w-full" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <button type="submit" className="btn-primary w-full">Send magic link</button>
        </form>
      </div>
    </div>
  )
}


